import React from 'react';
import PropTypes from 'prop-types';
import CacViewComponent from './CacViewComponent';
import CacBuildComponent from './CacBuildComponent';
import { CAC_LEFT_PANEL_VIEW_LABEL, CAC_LEFT_PANEL_BUILD_LABEL } from './CacConstants';

const CacMainContainer = props => {
  const { project, project: { leftPanel }, redrawChart } = props;
  return (
    <div className="CacMainContainer" data-test="CacMainContainer">
      {leftPanel === CAC_LEFT_PANEL_VIEW_LABEL &&
        (<CacViewComponent
          project={project}
          redrawChart={redrawChart}
        />)
      }
      {leftPanel === CAC_LEFT_PANEL_BUILD_LABEL &&
        (<CacBuildComponent
          project={project}
        />)
      }
    </div>
  );
};

CacMainContainer.propTypes = {
  redrawChart: PropTypes.bool,
  project: PropTypes.shape({
    leftPanel: PropTypes.string,
  }),
};

export default CacMainContainer;
